import React, { ReactNode } from "react";
import Modal from "./common/Modal";
import "../styles/marketing-modals.css";

interface MarketingModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  maxWidth?: string;
  className?: string;
}

const MarketingModal: React.FC<MarketingModalProps> = ({
  className = "",
  ...props
}) => (
  <Modal
    {...props}
    className={`marketing-modal ${className}`}
    mobileFullScreen={false}
  />
);

export default MarketingModal;
